import React from 'react'
import Reflux from 'reflux'
import {
	Input,
	Button
} from 'reactstrap'
import axios from 'axios'

import IngredientsStore from '~/stores/ingredients.js'
import QuantitiesStore from '~/stores/quantities.js'
import CurrentRecipeStore from '~/stores/currentRecipe.js'
import QuantitiesActions from '~/actions/quantities.js'
import IngredientsActions from '~/actions/ingredients.js'
import CurrentRecipeActions from '~/actions/currentRecipe.js'
import SimpleSelect from '~/modules/_core/simpleSelect.jsx'

import apiUtils from '../../helper/api.js'


export default class RecipeIngredientsAdd extends Reflux.Component {
	constructor(props) {
		super(props)

		this.state = {
			quantities: [],
			ingredients: [],
			amount: '',
			quantityID: 0,
			ingredientID: 0
		}

		this.stores = [CurrentRecipeStore, IngredientsStore, QuantitiesStore]
		this.storeKeys = [
			'recipeID',
			'quantities',
			'ingredients'
		]
	}

	saveEdit = () => {
		const formData = {
			recipeID: this.state.recipeID,
			amount: this.state.amount,
			quantityID: parseInt(this.state.quantityID, 10),
			ingredientID: parseInt(this.state.ingredientID, 10)
		}

		axios.post(`${apiUtils.getApiURL()}/recipeIngredients`, formData)
			.then(
				() => {
					this.setState({
						amount: '',
						quantityID: 0,
						ingredientID: 0
					})
					CurrentRecipeActions.getRecipeIngredients()
				}
			)
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	render() {
		return (
			<tbody>
				<tr>
					<td>
						<Input
							name="amount"
							value={this.state.amount || ''}
							onChange={this.handleChange}
							style={{ textAlign: 'right' }}
						/>
					</td>
					<td>
						<SimpleSelect
							onChange={this.handleChange}
							name="quantityID"
							value={this.state.quantityID}
							options={this.state.quantities}
							itemKeyValue="quantityID"
							itemKeyLabel="quantity"
							labelForBlank="Select Quantity"
						/>
						<Button
							color="info"
							size="sm"
							onClick={QuantitiesActions.showModal}
							block
						>
							Manage Quantity Options
						</Button>
					</td>
					<td>
						<SimpleSelect
							onChange={this.handleChange}
							name="ingredientID"
							value={this.state.ingredientID}
							options={this.state.ingredients}
							itemKeyValue="ingredientID"
							itemKeyLabel="ingredient"
							labelForBlank="Select Ingredient"
						/>
						<Button
							color="info"
							onClick={IngredientsActions.showModal}
							size="sm"
							block
						>
							Manage Ingredient Options
						</Button>
					</td>
					<td colSpan="2">
						<Button
							color="success"
							onClick={this.saveEdit}
							block
						>
							Add ingredient
						</Button>
					</td>
				</tr>
			</tbody>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeIngredients/add.jsx